import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Certificates = () => {
  const certificates = [
    {
      id: 1,
      name: "FSSAI Certificate",
      image:
        "https://images.unsplash.com/photo-1581093458791-9d42e6b5d5b2?q=80&w=1200&auto=format&fit=crop",
    },
  ];

  return (
    <>
      <Navbar />

      <div className="px-4 md:px-10 py-10 bg-gray-50 min-h-screen">
        
        {/* Heading */}
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-green-700">
            Our Certificates
          </h1>

          <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
            We are committed to quality, safety, and compliance standards.
            Our certifications ensure trusted and reliable herbal products.
          </p>
        </div>

        {/* Certificates Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          
          {certificates.map((certificate) => (
            <div
              key={certificate.id}
              className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300"
            >
              <img
                src={certificate.image}
                alt={certificate.name}
                className="w-full h-72 object-cover"
              />

              <div className="p-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  {certificate.name}
                </h2>

                <button
                  className="mt-4 w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
                >
                  View Certificate
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Certificates;